<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      :ok-title="$t('save')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span v-if="isUpdated">{{ form.name }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Panel')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Panel')"
                vid="panel_id"
                rules="required"
              >
                <v-select
                  v-model="form.panel_id"
                  :options="additionalData.panels"
                  :clearable="false"
                  label="name"
                  :reduce="_panel => _panel.id"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Period')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Period')"
                vid="period"
                rules="required"
              >
                <v-select
                  v-model="form.period"
                  :options="additionalData.periods"
                  :clearable="false"
                  :reduce="_period => _period.key.toString()"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Price')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Price')"
                vid="price"
                rules="required"
              >
                <b-form-input
                  id="price"
                  v-model="form.price"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Price')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Discount')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Discount')"
                vid="discount"
                rules="required"
              >
                <b-form-input
                  id="discount"
                  v-model="form.discount"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Discount')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("save") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../../common/mixins/form'

export default {
  name: 'PackagesEditModal',
  components: {

  },
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'packages',
      modalName: 'modal-packages-edit',
      useRouteName: true,
      createAbleFields: [
        'panel_id',
        'period',
        'price',
        'discount',
      ],
    }
  },
}
</script>

<style scoped>

</style>
